import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';

import { Select, SelectOption } from '../../../../atoms/select/select';

export function PagePickerContents({
  pageIndex,
  handlePageChange,
  currentPage,
  pageCount,
}: {
  readonly pageIndex: number;
  readonly handlePageChange: (value: string) => void;
  readonly currentPage: number;
  readonly pageCount: number;
}) {
  const { t } = useTranslation();
  const labelId = useId();
  const selectId = useId();
  return (
    <>
      <label htmlFor={selectId} id={labelId}>
        {t('ui-components.table.pagination.page')}
      </label>
      <Select
        aria-labelledby={labelId}
        className="w-24"
        defaultValue={pageIndex.toString()}
        id={selectId}
        onValueChange={handlePageChange}
        value={currentPage.toString()}
      >
        {Array.from({ length: pageCount }, (_, i) => (
          <SelectOption key={i} value={i.toString()}>
            {i + 1}
          </SelectOption>
        ))}
      </Select>
      <span aria-live="polite" className="whitespace-nowrap">
        {t('ui-components.table.pagination.of')} {pageCount}
      </span>
    </>
  );
}
